/* Chart.ts */

export enum ChartType {
  BAR = "bar",
  HISTOGRAM = "histogram",
  BOX = "box",
  STATS = "stats",
  SCATTER = "scatter",
  TABLE = "table",
  SANKEY = "sankey",
}

export enum SankeyBoxplotType {
  TIME_TO_NEXT_TREATMENT = "Time to next treatment",
  DURATION_OF_TREATMENT = "Duration of treatment",
  TIME_WITHOUT_TREATMENT = "Time without treatment",
  TIME_TO_TREATMENT = "Time to treatment",
}
